export interface KPITimeType {
  type: string;
  abbreviation: string;
  description: string;
}

export const KPI_TIME_TYPES: Record<string, KPITimeType> = {
  'Monthly Values': {
    type: 'Monthly Values',
    abbreviation: 'MTD',
    description: 'Data for a single calendar month or current month-to-date'
  },
  'Year to Date': {
    type: 'Year to Date',
    abbreviation: 'YTD',
    description: 'Cumulative data from the beginning of the current fiscal year to the current date'
  },
  'Calendar Year to Date': {
    type: 'Calendar Year to Date',
    abbreviation: 'CYTD',
    description: 'Cumulative data from January 1st to the current date'
  },
  'Fiscal Year to Date': {
    type: 'Fiscal Year to Date',
    abbreviation: 'FYTD',
    description: 'Cumulative data from the start of the organization\'s fiscal year to present'
  },
  'Quarter to Date': {
    type: 'Quarter to Date',
    abbreviation: 'QTD',
    description: 'Cumulative data from the beginning of the current quarter to the current date'
  },
  'Week to Date': {
    type: 'Week to Date',
    abbreviation: 'WTD',
    description: 'Data accumulated from the start of the current week to present'
  },
  'Rolling 3 Months': {
    type: 'Rolling 3 Months',
    abbreviation: 'R3',
    description: 'Continuous 3-month period ending with the most recent month'
  },
  'Rolling 6 Months': {
    type: 'Rolling 6 Months',
    abbreviation: 'R6',
    description: 'Continuous 6-month period ending with the most recent month'
  },
  'Rolling 12 Months': {
    type: 'Rolling 12 Months',
    abbreviation: 'R12',
    description: 'Continuous 12-month period ending with the most recent month'
  },
  'Prior Year': {
    type: 'Prior Year',
    abbreviation: 'PY',
    description: 'Data from the same period in the previous year'
  },
  'Prior Month': {
    type: 'Prior Month',
    abbreviation: 'PM',
    description: 'Data from the immediately preceding month'
  },
  'Prior Quarter': {
    type: 'Prior Quarter',
    abbreviation: 'PQ',
    description: 'Data from the immediately preceding quarter'
  }
};

// Helper to get all valid types as array
export const VALID_KPI_TIME_TYPES = Object.keys(KPI_TIME_TYPES);

// Reverse lookup: abbreviation to full type name
export const ABBREVIATION_TO_TYPE: Record<string, string> = {
  'MTD': 'Monthly Values',
  'YTD': 'Year to Date',
  'CYTD': 'Calendar Year to Date',
  'FYTD': 'Fiscal Year to Date',
  'QTD': 'Quarter to Date',
  'WTD': 'Week to Date',
  'R3': 'Rolling 3 Months',
  'R6': 'Rolling 6 Months',
  'R12': 'Rolling 12 Months',
  'PY': 'Prior Year',
  'PM': 'Prior Month',
  'PQ': 'Prior Quarter'
};

// Helper to get all valid abbreviations as array
export const VALID_ABBREVIATIONS = Object.keys(ABBREVIATION_TO_TYPE);

// Helper to get abbreviation from type
export const getAbbreviation = (type: string): string => {
  return KPI_TIME_TYPES[type]?.abbreviation || 'MTD';
};

// Helper to get description from type
export const getDescription = (type: string): string => {
  return KPI_TIME_TYPES[type]?.description || '';
};

// Helper to get full metadata
export const getTimeTypeMetadata = (type: string): KPITimeType | null => {
  return KPI_TIME_TYPES[type] || null;
};

// Convert abbreviation to full type name (case-insensitive)
export const getTypeFromAbbreviation = (abbreviation: string): string | null => {
  return ABBREVIATION_TO_TYPE[abbreviation.toUpperCase()] || null;
};

